import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";
import React from "react";
import { useTranslation } from "@coworker/locales";
import { useParams } from "react-router";

export const useDefaultScannerBehavior = () => {
  const { type: taskTypeParam } = useParams<{ type?: TaskType }>();
  const taskType: TaskType = taskTypeParam ?? TaskType.NO_TASK_TYPE;
  const [error, setError] = React.useState<string | null>(null);
  const navigate = useFixaNavigate();
  const navigateToSearch = () => navigate(`/product-search/${taskType}`);
  const { t } = useTranslation();
  const readyToScanText = t("readyToScanString");

  return {
    navigateToSearch,
    error,
    readyToScanText,
    setError,
    taskType,
  };
};
